import {MuWidget} from "mu-widget/lib/MuWidget";

export class MultiUpload extends MuWidget {
	beforeIndex() {
		this.container.innerHTML = '<div mu-id="items"><div mu-template="item" mu-widget="MutiUploadItem" class="multiupload--item"><span class="multiupload--item--remove btn btn-sm btn-danger" mu-id="bRemove">Odebrat</span>'
			+ '<div mu-id="content" class="multiupload--item--content" mu-bind="content:@foreach">'
			+ '<div mu-template="." class="multiupload--item--content--file" mu-widget="."><span mu-bind="name"></span></div>'
			+ '</div>'
			+ (this.container.innerHTML || '<input type="file" multiple mu-id="input" />')
			+ '<div mu-id="prompt" class="multiupload--item--prompt">Klikněte nebo přetáhněte přílohy</div>'
			+ '</div></div>'
			+ '<progress mu-id="progress"></progress>';
		this.container.classList.add('multiupload');
		/* const newContainer = document.createElement('div');
		container.parentElement.insertBefore(newContainer, container);
		container.parentElement.removeChild(container);
		newContainer.appendChild(container);
		container = newContainer;
		(container as any).widget = this;

		container.innerHTML += '<span mu-id="b">sss</span>';
		this.container = container; */
		this.muRegisterEvent('uploadStatus', 'change');
	}

	afterIndex() {
		this.addItem();
		this.muVisible(false, 'progress');
	}

	public addItem() {
		const current = this.ui.items.firstElementChild;
		// @ts-ignore
		if (current) ((current as any).widget as MutiUploadItem).lock();
		this.muWidgetFromTemplate('item', 'items', {}, 'first');
	}

	sendToBackend(
		prepareCallback: (context: UploadContext, send: () => Promise<UploadContext>) => void
	): Promise<UploadContext[]> {
		this.muVisible(true, 'progress');
		return new Promise<UploadContext[]>((resolve, reject) => {
			const uctxs = this.getAllFiles().map(file => <UploadContext>{
				url: "",
				method: "POST",
				headers: {
					'Content-Type': 'application/octet-stream'
				},
				res: null,
				status: "wait",
				resIsJson: true,
				file: file
			});

			const checkFinal = () => {
				const res = {
					total: uctxs.length,
					done: uctxs.filter(uc => ['ok', 'error'].includes(uc.status)).length,
					contexts: uctxs,
				};
				if (res.done == res.total) {
					resolve(uctxs);
					this.muVisible(false, 'progress');
				}
				this.muDispatchEvent('uploadStatus', res);
				this.ui.progress.max = res.total.toString();
				this.ui.progress.value = res.done.toString();
			};
			checkFinal();
			for(const uctx of uctxs) {
				prepareCallback(uctx, () => new Promise((resolve, reject) => {
					fetch(
						uctx.url,
						{
							method: uctx.method,
							headers: uctx.headers,
							body: uctx.file,
						}
					).then(async (res) => {
						uctx.status = "ok";
						uctx.res = uctx.resIsJson ? await res.json() : await res.text();
						resolve(uctx);
						checkFinal();
					}, reason => {
						uctx.status = "error";
						uctx.error = reason;
						reject(uctx);
						checkFinal();
					});
					checkFinal();
					uctx.status = "sending";
				}));
			}
		});
	}

	public getAllFiles(): File[] {
		return this.muGetChildWidgets<MutiUploadItem>('items')
			.reduce((p, n) => [...p, ...n.getAllFiles()], <File[]>[])
	}
}

export type UploadContext = {
	url: string,
	method: string,
	status: "wait"|"sending"|"ok"|"error",
	res: any|null,
	resIsJson: boolean,
	headers: {
		[key: string]: string
	},
	[key: string]: any,
	file: File,
}

export class MutiUploadItem extends MuWidget {
	// @ts-ignore
	muParent: MultiUpload;
	public lock(isLocked : boolean = true) {
		this.container.classList.toggle('multiupload--item__locked', isLocked);
	}
	afterIndex() {
		this.lock(false);
	}

	bRemove_click() {
		this.muRemoveSelf();
	}

	input_change() {
		this.lock();
		this.muBindData({
			content: this.getAllFiles().map(
				file => <any>{name: (file as File).name})});
		this.muParent.addItem();
	}

	public getAllFiles(): File[] {
		// @ts-ignore
		return Array.from(this.ui.input.files);
	}
}